import { useLocalMutationsState } from './useLocalMutationsState';
import { useCallback, useMemo } from 'react';
export const useSingleObjectsWithLocalMutations = objectTypeId => {
  const selector = useCallback(state => {
    return state.individualObjects[objectTypeId];
  }, [objectTypeId]);
  const objectTypeMutations = useLocalMutationsState(selector);
  return useMemo(() => {
    return objectTypeMutations ? Object.keys(objectTypeMutations) : [];
  }, [objectTypeMutations]);
};